import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetInvoicesPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/invoices/models/inputs/get-invoices-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterInvoiceListContext } from '../../invoice.context';
import { InvoiceListFilterFormStep1Controller } from '../invoice-list-filter-form-step-1/invoice-list-filter-form-step-1.controller';

export interface InvoiceListFilterFormControllerProps {
  onError: SubmitErrorHandler<GetInvoicesPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetInvoicesPaginatedModel>;
  onCancel: () => void;
}

export const InvoiceListFilterFormController = (
  props: InvoiceListFilterFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterInvoiceListContext();

  return (
    <MultiStepFormProvider<GetInvoicesPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      items={[
        {
          fields: ['customerId', 'networkId', 'status', 'type'],
          component: <InvoiceListFilterFormStep1Controller />,
        },
      ]}
    />
  );
};
